var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from 'modules/v2/foundation/Box';
import { ListItemContainer, ListItemContainerInner } from './styled';
export function ListItem(props) {
    const { children, action, disabled, selected } = props, rest = __rest(props, ["children", "action", "disabled", "selected"]);
    const handleActionsClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };
    return (<ListItemContainer $selected={selected}>
      <ListItemContainerInner disabled={disabled} {...rest}>
        {children}
      </ListItemContainerInner>
      {action && (<Box ml="auto" pr="md" onClick={handleActionsClick}>
          {action}
        </Box>)}
    </ListItemContainer>);
}
